export default __webpack_public_path__ + "static/media/upload.8ec5d1b9.svg";